import React from "react";
import MoreButton from "./MoreButton";

const FeatureDreamHead = () => {
    return (
        <div className="relative overflow-hidden bg-white">
            <div className="pt-16 sm:pt-24 lg:pt-40 lg:pb-52">
                <div className="relative mx-auto max-w-7xl px-5 sm:static sm:px-10 lg:px-8
                flex align-top justify-between sm:flex-row flex-col gap-8 lg:gap-4">
                    <div className="sm:max-w-lg z-10 w-[100%] md:w-[55%]">
                        <h1 className="text-h1 font-bold tracking-tight text-gray-900">
                            무엇이든 연결할 수 있는
                            <br/>자동생성 API
                        </h1>
                        <p className="mt-4 font-bold text-brand text-h3">
                            레거시 데이터부터 실시간 API까지,<br/>
                            즉각적인 성과 구현
                        </p>
                        <p className="mt-4 text-gray-500 text-body">
                            &quot;모든 SQL 데이터베이스의 구조화된 데이터를 <br/>
                            보안 API로 활용하고, 방화벽 내부에서 <br/>
                            대시보드, 자동화, AI 기능까지 구현하세요.&quot;
                        </p>
                        <MoreButton className="mt-10" />
                    </div>

                    <div className="hidden md:block absolute right-[120px] z-0 w-[48%] top-[50%] translate-y-[-50%]">
                        <img
                            src="/img/integrate_banner_img.svg"
                            alt=""
                            className="h-full w-[100%] object-cover object-center"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeatureDreamHead;